<wct-horizontal-layout [spaceBetween]="true">
  <div class="sd-display sd-display--size-3xl">Ihre Fonds</div>
  <div>
    <sd-4-5-1-link href="{{ allFondsUrl }}">
      <span>{{ 'fundList.gotoAdvanced' | transloco }}</span>
      <sd-4-5-1-icon
        slot="icon-right"
        library="{{ iconLibrary }}"
        name="system/arrow-right"></sd-4-5-1-icon>
    </sd-4-5-1-link>
  </div>
</wct-horizontal-layout>

<wct-spacer [spacingAmount]="0.5"/>

<sd-4-5-1-radio-group
  size="sm" [value]="fundsVisibility()">

  <sd-4-5-1-tooltip
    trigger="hover focus"
    placement="top"
    content="{{ 'advancedFundList.ownFundsTooltip' | transloco }}"
  >
    <sd-4-5-1-radio-button
      value="user"
      (click)="fundsVisibility.set('user')">
      <span>{{ 'advancedFundList.ownFunds' | transloco }}</span>
    </sd-4-5-1-radio-button>
  </sd-4-5-1-tooltip>

  <sd-4-5-1-tooltip
    trigger="hover focus"
    placement="top"
    content="{{ 'advancedFundList.specialFundsTooltip' | transloco }}"
  >
    <sd-4-5-1-radio-button
      value="special"
      (click)="fundsVisibility.set('special')">
      <span>{{ 'advancedFundList.specialFunds' | transloco }}</span>
    </sd-4-5-1-radio-button>
  </sd-4-5-1-tooltip>
</sd-4-5-1-radio-group>

<wct-spacer/>

<app-bo-table
  *rptHandleErrors
  [documentId]="cuid()"
  [actionHandler]="actionHandler"
  [filterSelections]="preconfiguredFilter">

  <wct-no-search-results
    empty
    [icon]="'system/info-circle'"
    [headline]="'fondsOverview.noFunds.header' | transloco"
    [message]="'fondsOverview.noFunds.message' | transloco"
    [displayResetButton]="false"/>

</app-bo-table>
